/**
 * @fileoverview POST handler for the "/open_ai/liquid_assistant_with_diffs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { openAiLiquidAssistantWithDiffsCacheKeys } from "./constants";
import type { OpenAiLiquidAssistantWithDiffsResponse, PostOpenAiLiquidAssistantWithDiffsProps } from "./types";

export const postOpenAiLiquidAssistantWithDiffs = reactQueryMutationAdapter(
  openAiLiquidAssistantWithDiffsCacheKeys,
  (props: PostOpenAiLiquidAssistantWithDiffsProps): Promise<OpenAiLiquidAssistantWithDiffsResponse> => {
    return fetch("/open_ai/liquid_assistant_with_diffs", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
